import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { styled } from '@mui/system';
import uuid from 'uuid-random';
import { getLanguage } from 'translation';

const StyledStack = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gap: 4
  }
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    height: 26
  },
  '& span': {
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      lineHeight: '10px',
      paddingLeft: 9,
      paddingRight: 9
    }
  }
}));

const Tags = ({ list, onClick, onDelete, limit, isCard }) => {
  const [expendedList, setExpendedList] = React.useState(false);
  const [lang] = React.useState(getLanguage().toUpperCase());

  if (!list) return null;

  return (
    <StyledStack direction="row">
      {list.map((props, index) => {
        if (!expendedList && index >= limit) return null;

        const { _id } = props[lang] || props;

        const title = props?.value || props?.name || props?.title || props;

        return (
          <StyledChip
            key={uuid() + _id}
            label={title}
            onClick={onClick ? () => onClick(_id) : null}
            onDelete={onDelete ? () => onDelete(_id, 'delete') : null}
          />
        );
      })}
      {list.length > limit && !isCard ? (
        <IconButton
          aria-label="show more"
          onClick={() => setExpendedList(!expendedList)}
          size="small">
          {expendedList ? <ExpandLessIcon /> : <MoreHorizIcon />}
        </IconButton>
      ) : null}
    </StyledStack>
  );
};

export default Tags;
